import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';

import { deleteProduct } from '../../actions/productActions';
import { formatNumber } from '../../utils/orderService';
import ToggleDisableStatus from './ToggleDisableStatus';
import { text16 } from '../Styles/index';
const Warning = styled.div`
  background-color: rgba(244, 67, 54,.25);
  padding: 16px;
  color: #C62828;
  border-radius: 4px;
  margin-bottom: 24px
`


const DeleteDialog = (props) => (
  <Dialog
    title="Delete Product"
    actions={props.actions}
    modal={false}
    open={props.open}
    onRequestClose={props.handleClose}
  >
    <div style={{ marginBottom: '24px' }}>
      Product Code: {props.product.key}
    </div>
    <Warning>
      After you delete an product, it's permanently deleted. Products can't be undeleted.
    </Warning>
    <div>
      <pre style={{ width: '100%', backgroundColor: '#dfdfff', color: '#333', padding: "8px 16px", borderRadius: "4px", overflow: 'auto' }}>
        <code style={{ lineHeight: 1.25 }}>
          {`${JSON.stringify(props.product, undefined, 2)}`}
        </code>
      </pre>
    </div>
  </Dialog>
)


class ProductsTable extends Component {
  state = {
    fixedHeader: true,
    fixedFooter: true,
    stripedRows: false,
    showRowHover: false,
    selectable: false,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    height: `${96 + this.props.height}px`,

    openDialog: false,
    productToDelete: {},

  }

  _handleDialogCloseRequest = event => {
    this.setState({
      openDialog: false,
      productToDelete: {}
    })
  }

  _handleDialogOpenRequest = (event, product) => {
    this.setState({
      openDialog: true,
      productToDelete: product
    })
  }

  _dialogActions(){
    return [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this._handleDialogCloseRequest}
      />,
      <form style={{display: 'inline-block'}} onSubmit={this._handleDeleteProduct}>
        <RaisedButton
          label="Delete"
          type="submit"
          backgroundColor="#F44336"
          labelStyle={{ color: 'white' }}
        />
      </form>,
    ]
  }

  _handleDeleteProduct = event => {
    event.preventDefault();
    this.props.deleteProduct({ key: this.state.productToDelete.key })
      .then(_ => {
        if (this.props.product.status === 'deleted') {
          this.props.refreshPage();
        }
      })
    this.setState({
      openDialog: false,
    })
  }


  render() {
    if (this.props.tableData.length === 0) {
      return <div style={{padding: '32px 0'}}><h2 style={{fontWeight: 600, fontSize: 24, textAlign: 'center'}}>No products data!</h2></div>
    }
    return (
      <div>
        <Table
          style={{tableLayout: 'auto'}}
          bodyStyle= {{ overflowX: undefined, overflowY: undefined }}
          height={this.state.height}
          fixedFooter={this.state.fixedFooter}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
        >
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
            <TableRow>
              {this.props.headers.map((header, index) => {
                return <TableHeaderColumn key={index} tooltip={header} style={{ textAlign: (index === 4 || index === 5) ? 'right': 'left'}}>{header}</TableHeaderColumn>
              })}
            </TableRow> 
            {this.props.tableData.map( (row, index) => (
              <TableRow key={index}>
                <TableRowColumn style={text16}>{index+1}</TableRowColumn>
                <TableRowColumn style={text16}>{row.key}</TableRowColumn>
                <TableRowColumn style={text16}>{row.product_name}</TableRowColumn>
                <TableRowColumn style={text16}>{row.pcscase}</TableRowColumn>
                <TableRowColumn style={{...text16, textAlign: 'right'}}>{formatNumber(row.product_quantity, true)}</TableRowColumn>
                <TableRowColumn style={{...text16, textAlign: 'right'}}>{formatNumber(row.price_item)}</TableRowColumn>
                <TableRowColumn style={text16}>{row.rimbursimi}</TableRowColumn>
                <TableRowColumn style={text16}>{row.pa}</TableRowColumn>
                <TableRowColumn style={text16}>{row.categories}</TableRowColumn>
                <TableRowColumn style={text16}>{row.zbritje}%</TableRowColumn>
                <TableRowColumn style={text16}>{row.tvsh}</TableRowColumn>
                <TableRowColumn style={text16}>{row.skadenca}</TableRowColumn>
                <TableRowColumn style={text16}>{row.parent_category}</TableRowColumn>
                <TableRowColumn>
                  <RaisedButton label="Edit" buttonStyle={{lineHeight: '28px'}} style={{height: '28px'}} labelStyle={{height: 'auto', color: 'white'}} backgroundColor="#4CAF50" onTouchTap={(event) => this.props.editHandler(row.key)} />
                  <span style={{width: '8px', display: 'inline-block'}}></span>
                  <RaisedButton label="Delete" buttonStyle={{lineHeight: '28px'}} style={{height: '28px'}} labelStyle={{height: 'auto', color: 'white'}} backgroundColor="#F44336" onTouchTap={event => this._handleDialogOpenRequest(event, row)} />
                  <span style={{width: '8px', display: 'inline-block'}}></span>
                  <ToggleDisableStatus id={row.key} active={row.is_active}></ToggleDisableStatus>
                </TableRowColumn>
              </TableRow>
              ))}
          </TableBody>
        </Table>
        <div>
          <DeleteDialog
            open={this.state.openDialog}
            actions={this._dialogActions()}
            handleClose={this._handleDialogCloseRequest}
            product={this.state.productToDelete}></DeleteDialog>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({ product: state.product.deleted });
const mapDispatchToProps = { deleteProduct };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductsTable));



// WEBPACK FOOTER //
// ./src/components/Products/ProductsTable.js